var Article;

Article = function(self, options) {
  Modelize(self, {
    api: api.articles,
    editable: ['title', 'content', 'pretext', 'published_at', 'active', 'author_id', 'option_display_title', 'option_fix_title'],
    has_many: ['asset']
  });
  Observable(self, 'asset', null);
  Observable(self, 'saving', false);
  ObservableArray(self, 'tags', []);
  self.set_cover = (function(_this) {
    return function(asset, callback) {
      return self.update({
        asset_id: asset.id
      }, callback);
    };
  })(this);
  self.unset_cover = (function(_this) {
    return function(callback) {
      return self.update({
        asset_id: 0
      }, callback);
    };
  })(this);
  self.add_tag = (function(_this) {
    return function(tag, callback) {
      if (self.has_tag(tag)) {
        return;
      }
      self.saving(true);
      return api.articles.tags.create(self.id, {
        id: tag.id
      }).done(function(data, e) {
        if (callback != null) {
          callback(data, e);
        }
        if (!self.has_tag(tag)) {
          self.tags.push(tag);
        }
        return self.saving(false);
      });
    };
  })(this);
  self.remove_tag = (function(_this) {
    return function(tag_id, callback) {
      return api.articles.tags.destroy(self.id, tag_id).done(callback);
    };
  })(this);
  self.create_tag = (function(_this) {
    return function(tag_name) {
      var tag;
      tag = null;
      return ArticleTag.create(tag_name, function(data) {
        tag = ArticleTag(data);
        return self.add_tag(tag);
      });
    };
  })(this);
  self.has_tag = (function(_this) {
    return function(tag) {
      var t, _i, _len, _ref;
      if (self.tags().length === 0) {
        return false;
      }
      _ref = self.tags();
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        t = _ref[_i];
        if (tag.id === t.id) {
          return true;
        }
      }
      return false;
    };
  })(this);
  self.has_tags = (function(_this) {
    return function(tags) {
      var r, tag, _i, _len;
      if (tags.length === 0) {
        return true;
      }
      r = [];
      for (_i = 0, _len = tags.length; _i < _len; _i++) {
        tag = tags[_i];
        if (self.has_tag(tag)) {
          r.push(true);
        }
      }
      return r.length === tags.length;
    };
  })(this);
  return self;
};

if (api.articles == null) {
  api.add('articles');
}

api.articles.add('assets');

api.articles.add('tags');

Collection(Article, api.articles);

//# sourceMappingURL=article.js.map
